import axios from 'axios'
import qs from 'qs';
import {dismissLoading} from '../libs/LoadingUtil';
import * as Cache from '../cache/Cache';

axios.defaults.timeout = 30 * 1000;

const HEADERS = {'Content-Type': 'application/x-www-form-urlencoded;'};

const serializeJSON = data => {
  if (!data) {
    return '';
  }
  return Object.entries(data).map(([key, value]) => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  }).join('&');
};


export const get = (url, params, success= ()=>{}, fail = ()=>{})=>{
// console.log(`【${url}】发起请求  body = ${JSON.stringify(params.body)}`);
  let serialzeBody = serializeJSON(params.body);
  let realBody = serialzeBody ? '?' + serialzeBody : '';
  let headers = params.headers ? params.headers : {};
  axios({
    method: 'get',
    url : url + realBody,
    headers:{...HEADERS, ...headers},
  }).then(res => {
    handleResp(url, params.body, res, success, fail);
  }).catch((error)=>{
 console.log(`【${url}】返回异常 `, error);
    failCallback(fail, createFailRespObj('网络异常'));
  });
}

export const qsPost = (url, params, success= ()=>{}, fail = ()=>{})=>{
  //请求体里放userid
  let userInfo = Cache.getUserInfo();
  if(userInfo){
    params.body.userid = userInfo.userid;
  }
// console.log(`【${url}】发起请求  body = ${JSON.stringify(params.body)}`);
  let headers = params.headers ? params.headers : {};
  axios({
    method: 'post',
    url : url,
    data: qs.stringify(params.body),
    headers:{...HEADERS, ...headers},
  }).then(res => {
    handleResp(url, params.body, res, success, fail);
  }).catch((error)=>{
 console.log(`【${url}】返回异常 `, error);
    failCallback(fail, createFailRespObj('网络异常'));
  });
}

export const post = (url, params, success= ()=>{}, fail = ()=>{})=>{
// console.log(`【${url}】发起请求  body = ${JSON.stringify(params.body)}`);
  let headers = params.headers ? params.headers : {};
  axios({
    method: 'post',
    url : url,
    data: params.body,
    headers:{...HEADERS, ...headers},
  }).then(res => {
    handleResp(url, params.body, res, success, fail);
  }).catch((error)=>{
 console.log(`【${url}】返回异常 `, error);
    failCallback(fail, createFailRespObj('网络异常'));
  });
}

/** 对返回结果进行处理 */
const handleResp = (url, body, resp, success, fail)=>{
  let respData = resp.data;
  let status = resp.status;
  if(status === 200) {
//  console.log(`【${url}】请求返回数据：`,JSON.stringify(respData));
    if(respData.resultCode == '0000') {
      if(success) {
        success(respData);
      }
    } else {
      failCallback(fail, respData);
    }

  } else {
 console.log(`【${url}】请求异常：`,JSON.stringify(resp));
    failCallback(fail, createFailRespObj(resp.message ? resp.message : '网络异常'));
  }
}

/** 弹窗提示 */
const showAlert = (msg)=>{
  if(global.vm) {
    global.vm.$Notice.error({
      title: '提示',
      desc: msg,
    });
  }
}

const failCallback = (failCallback, resp) => {
  dismissLoading();
  if(resp && resp.resultMsg) {
    showAlert(resp.resultMsg);
  }
  if(failCallback) {
    failCallback(resp);
  }
}

const createFailRespObj = (errorMsg) => {
  return {resultMsg: errorMsg};
}



// WEBPACK FOOTER //
// ./src/api/ApiHelper.js